<h2 mat-dialog-title>
  <mat-icon class="icon-20" >person_add</mat-icon> Add User 
</h2>
<form [formGroup]="userInfo">
  <div>
    <br />
    <mat-card appearance="outlined" [style.backgroundColor]="'LightGray'">
      <div class="flex flex-row flex-wrap gap-2">

        <div class="flex-1 min-w-[50%] sm:min-w-full" *ngIf="user?.address != null && user?.address.length > 0">
          <em class="text-muted">Address: &nbsp;&nbsp;</em>
          <span>{{user?.address}} {{user?.city}} {{user?.state}} {{user?.zip}}</span>
        </div>

        <div class="flex-1 min-w-[50%] sm:min-w-full" *ngIf="user?.mobile != null && user?.mobile.length > 0">
          <em class="text-muted">Mobile: &nbsp;&nbsp;</em>
          <span>{{user?.mobile}}</span>
        </div>

        <div class="flex-1 min-w-[50%] sm:min-w-full" >
          <mat-form-field class="w-full">
            <mat-label>User Name</mat-label>
            <input matInput placeholder="User Name" formControlName="userName">
            <mat-error *ngIf="userInfo.get('userName').invalid">
              Required Field
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex-1 min-w-[50%] sm:min-w-full" >
          <mat-form-field class="w-full">
            <mat-label>Email</mat-label>
            <input matInput placeholder="Email" formControlName="email">
            <mat-error *ngIf="userInfo.get('email').invalid">
              Required Field
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex-1 min-w-[50%] sm:min-w-full" *ngIf="user?.phone != null && user?.phone.length > 0">
          <em class="text-muted">Phone: &nbsp;&nbsp;</em>
          <span>{{user?.phone}}</span>
        </div>

        <div class="flex-1 min-w-[50%] sm:min-w-full" *ngIf="user?.jobTitle != null && user?.jobTitle.length > 0">
          <em class="text-muted">Title: &nbsp;&nbsp;</em>
          <span>{{user?.jobTitle}}</span>
        </div>

        <div class="w-full">
          <br />
          <em class="text-muted">Roles: &nbsp;&nbsp;</em>
          <br />
          <span *ngFor="let role of roles">
            <mat-checkbox (change)="updateUserRole(role, $event)"
              >{{role}}</mat-checkbox><br />
          </span>
        </div>
      </div>

      <div>
        <br />
        <button mat-button (click)="saveUser()" color="primary">Save User</button>
        <button mat-button mat-dialog-close="Cancel" aria-label="Cancel">Cancel</button>
      </div>
    </mat-card>

  </div>
</form>
<!-- 
<div mat-dialog-content>Enter Employee Id or Email address below to find user<br /><br /></div>
<mat-form-field  [style.width.px]=327>
  <input matInput placeholder="Enter Employee Id or Email address" [(ngModel)]="filter">
</mat-form-field>
<div mat-dialog-actions>
  <button mat-button  (click)="findUser()" [disabled]="processing || filter == null || filter.length == 0">Find</button>
  <button mat-button mat-dialog-close="Cancel" aria-label="Cancel">Cancel</button>
</div>
<div *ngIf="user != null">
  <br />
  <mat-card appearance="outlined" [style.backgroundColor]="'LightGray'">
    <mat-card-title>{{user?.fullName}} ({{user?.userName}})</mat-card-title>
      <div class="flex flex-row flex-wrap gap-2">
        <div class="w-full">       
          <span>&nbsp;</span>
        </div>
  
        <div class="flex-1 min-w-[50%] sm:min-w-full" *ngIf="user?.email != null && user?.email.length > 0">   
          <em class="text-muted">Email:  &nbsp;&nbsp;</em>     
          <span>{{user?.email}}</span>
        </div>
  
        <div class="flex-1 min-w-[50%] sm:min-w-full" *ngIf="user?.address != null && user?.address.length > 0">   
          <em class="text-muted">Address:  &nbsp;&nbsp;</em>     
          <span>{{user?.address}} {{user?.city}} {{user?.state}} {{user?.zip}}</span>
        </div>
  
        <div class="flex-1 min-w-[50%] sm:min-w-full" *ngIf="user?.mobile != null && user?.mobile.length > 0">   
          <em class="text-muted">Mobile:  &nbsp;&nbsp;</em>     
          <span>{{user?.mobile}}</span>
        </div>
  
        <div class="flex-1 min-w-[50%] sm:min-w-full"  *ngIf="user?.phone != null && user?.phone.length > 0">   
          <em class="text-muted">Phone:  &nbsp;&nbsp;</em>     
          <span>{{user?.phone}}</span>
        </div>
        
        <div class="flex-1 min-w-[50%] sm:min-w-full"  *ngIf="user?.jobTitle != null && user?.jobTitle.length > 0">   
          <em class="text-muted">Title:  &nbsp;&nbsp;</em>     
          <span>{{user?.jobTitle}}</span>
        </div>
  
        <div class="w-full" >  
          <br /> 
          <em class="text-muted">Roles:  &nbsp;&nbsp;</em> 
          <br />
          <span *ngFor="let role of roles">
            <mat-checkbox (change)="updateUserRole(role, $event)">{{role}}</mat-checkbox><br />
          </span>
        </div>
      </div>

      <div> 
        <br />       
        <button mat-button  (click)="addUser()" [disabled]="processing || user == null" color="primary">Add User</button>
      </div>
  </mat-card>
  
  
</div> -->